import { Adapter } from "@app/shared/models/adapter.model";
import { Field } from "@app/shared/models/form-field.model";
import { CrudModes } from "@app/shared/components/abstracts/base-component";

/**
 * Enumerator: viewStates
 *
 * View component states
 *
 * Value to control which component is currently being displayed
 */
export enum viewStates {
  viewList,
  viewForm
}

/**
 * Class: RoleParms
 *
 * Parameters used to for user profile form
 */
export class RoleParms {
  constructor(
    public id: string,
    public mode: CrudModes,
    public parent: string
  ) {}
}

/**
 * Interface to display data on a table
 */
export interface RoleList {
  id: string;
  description: string;
  isSelected: boolean;
}

/**
 * Interface for an individual record
 */
export interface Role {
  id: Field;
  description: Field;
  add: Field;
  edit: Field;
  delete: Field;
  view: Field;
  report: Field;
  updateTimeStamp: string;
  menuItems: Field;
}

export interface RoleByMenuItemsList {
  menuId: string;
  roleId: string;
}

/**
 * node for menu item tree
 */
export class MenuItemNode {
  children: MenuItemNode[];
  item: string;
  menuId: string;
  level: number;
  isLegacy: boolean;
  componentId: string;
}

export class RolesAdapter implements Adapter<RoleList[]> {
  adapt(rawData: any): RoleList[] {
    (rawData.rolesList as RoleList[]).map((e) => {
      e.isSelected = false;
      return e;
    });
    return rawData.rolesList;
  }
}

export class RoleAdapter implements Adapter<Role> {
  adapt(rawData: any): Role {
    return rawData;
  }
}

export class RolesFilteredListAdapter implements Adapter<RoleList[]> {
  adapt(rawData: any): RoleList[] {
    return rawData?.rolesFilteredList;
  }
}

export class RoleByMenuItemsListAdapter implements Adapter<RoleByMenuItemsList[]> {
  adapt(rawData: any): RoleByMenuItemsList[] {
    return rawData?.rolesIdList ?? rawData?.rolesMenuIdList;
  }
}
